module.exports = __webpack_public_path__ + "static/media/optum_place2.0dd93535.jpg";